import { Record } from 'immutable';
import { actionTypes } from './title.actions';

export const TitleState = Record({
  currentTitle: '',
  currentMessage: ''
});

export const titleReducer = (state = new TitleState(), action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TITLE:
      return state.set('currentTitle', action.value);
    case actionTypes.UPDATE_MESSAGE:
      return state.set('currentMessage', action.value);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/common/title/title.reducer.js